import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import './LearnPage.css';
import IconAboutSvg from '../../components/IconAboutSvg/IconAboutSvg';

const LearnPage = () => {
  const intl = useIntl();

  return (
    <Page title="" scrollingDisabled={false}>
      <div className={'container'}>
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
          <div className="aboutpageContainer">
            <div className="aboutpageDescriptionContainer">
            <h2>{intl.formatMessage({ id: 'Learnpage.Buyer.titleMain' })}</h2>

              <div className='buyer'>
                <p className={'learnPageSectionTitle'}>{intl.formatMessage({ id: 'Learnpage.Buyer.title' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.description' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.description1' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle.description1' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle1.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle1.description1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle1.description2' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle2' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle2.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle2.description1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle2.description2' })}</p>
                <p>{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle3' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle3.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle3.description1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle3.description2' })}</p>
                <div className='learn_buyer_practice'>
                  <p>{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4' })}</p>
                  <p>1.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription' })}</p>
                  <p>2.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description1' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription1' })}</p>
                  <p>3.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description2' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription2' })}</p>
                  <p>4.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description3' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription3' })}</p>
                  <p>5.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description4' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription4' })}</p>
                  <p>6.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description5' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription5' })}</p>
                  <p>7.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description6' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription6' })}</p>
                  <p>8.	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.description7' })}</p>
                  <p>•	{intl.formatMessage({ id: 'Learnpage.Buyer.subTitle4.subDescription7' })}</p>
                </div>
              </div>
              <div className='seller'>
                <p className={'learnPageSectionTitle'}>{intl.formatMessage({ id: 'Learnpage.Seller.title' })}</p>
                <p>1. {intl.formatMessage({ id: 'Learnpage.Seller.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription2' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription3' })}</p>
                <p>2. {intl.formatMessage({ id: 'Learnpage.Seller.description1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription4' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription5' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription6' })}</p>
                <p>3. {intl.formatMessage({ id: 'Learnpage.Seller.description2' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription7' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription8' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription9' })}</p>
                <p>4. {intl.formatMessage({ id: 'Learnpage.Seller.description3' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription10' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription11' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription12' })}</p>
                <p>5. {intl.formatMessage({ id: 'Learnpage.Seller.description4' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription13' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription14' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription15' })}</p>
                <p>6. {intl.formatMessage({ id: 'Learnpage.Seller.description5' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription16' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription17' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription18' })}</p>
                <p>7. {intl.formatMessage({ id: 'Learnpage.Seller.description6' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription19' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Seller.subDescription20' })}</p>
              </div>
              <div className='key'>
                <p>{intl.formatMessage({ id: 'Learnpage.Key.title' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Key.description' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Key.description1' })}</p>
                <p>•	{intl.formatMessage({ id: 'Learnpage.Key.description2' })}</p>
              </div>
              <p>{intl.formatMessage({ id: 'Learnpage.description' })}</p>
            </div>
            <div className="aboutImage">
              <IconAboutSvg />
            </div>
          </div>
        </LayoutSingleColumn>
      </div>
    </Page>
  );
};

export default LearnPage;
